__turbopack_context__.v({
  "placeholder": "duration-toggle-module-scss-module__809h_q__placeholder",
  "toggle-button": "duration-toggle-module-scss-module__809h_q__toggle-button",
  "toggle-button-active": "duration-toggle-module-scss-module__809h_q__toggle-button-active",
  "wrapper": "duration-toggle-module-scss-module__809h_q__wrapper",
});
